module.exports = __webpack_public_path__ + "media/binaryadd.5c63a8d6.mp4";